// if (!customElements.get('media-gallery')) {
//   customElements.define(
//     'media-gallery',
//     class MediaGallery extends HTMLElement {
//       constructor() {
//         super();
//         this.elements = {
//           liveRegion: this.querySelector('[id^="GalleryStatus"]'),
//           viewer: this.querySelector('[id^="GalleryViewer"]'),
//           thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
//         };
//         this.mql = window.matchMedia('(min-width: 750px)');
//         if (!this.elements.thumbnails) return;

//         this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
//         this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
//           mediaToSwitch
//             .querySelector('button')
//             .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
//         });
//         if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
//       }

//       onSlideChanged(event) {
//         const thumbnail = this.elements.thumbnails.querySelector(
//           `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
//         );
//         this.setActiveThumbnail(thumbnail);

//         setTimeout(() => {
//           // Find all videos that are visible
//           const visibleVideos = document.querySelectorAll('.product-media-container video');
  
//           visibleVideos.forEach(video => {
//             if (video.paused) {
//               video.play().catch(e => {
//                 // Silent catch for autoplay restrictions
//                 console.log('Autoplay blocked:', e);
//               });
//             }
//           });
//         }, 200); // Delay to wait for DOM re-render

//       }

//       setActiveMedia(mediaId, prepend) {
//         const activeMedia =
//           this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
//           this.elements.viewer.querySelector('[data-media-id]');
//         if (!activeMedia) {
//           return;
//         }
//         this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
//           element.classList.remove('is-active');
//         });
//         activeMedia?.classList?.add('is-active');

//         if (prepend) {
//           activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

//           if (this.elements.thumbnails) {
//             const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
//             activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
//           }

//           if (this.elements.viewer.slider) this.elements.viewer.resetPages();
//         }

//         this.preventStickyHeader();
//         window.setTimeout(() => {
//           if (!this.mql.matches || this.elements.thumbnails) {
//             activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
//           }
//           const activeMediaRect = activeMedia.getBoundingClientRect();
//           // Don't scroll if the image is already in view
//           if (activeMediaRect.top > -0.5) return;
//           const top = activeMediaRect.top + window.scrollY;
//           window.scrollTo({ top: top, behavior: 'smooth' });
//         });
//         this.playActiveMedia(activeMedia);

//         if (!this.elements.thumbnails) return;
//         const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
//         this.setActiveThumbnail(activeThumbnail);
//         this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
//       }

//       setActiveThumbnail(thumbnail) {
//         if (!this.elements.thumbnails || !thumbnail) return;

//         this.elements.thumbnails
//           .querySelectorAll('button')
//           .forEach((element) => element.removeAttribute('aria-current'));
//         thumbnail.querySelector('button').setAttribute('aria-current', true);
//         if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

//         this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
//       }

//       announceLiveRegion(activeItem, position) {
//         const image = activeItem.querySelector('.product__modal-opener--image img');
//         if (!image) return;
//         image.onload = () => {
//           this.elements.liveRegion.setAttribute('aria-hidden', false);
//           this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
//           setTimeout(() => {
//             this.elements.liveRegion.setAttribute('aria-hidden', true);
//           }, 2000);
//         };
//         image.src = image.src;
//       }

//       playActiveMedia(activeItem) {
//         window.pauseAllMedia();
//         const deferredMedia = activeItem.querySelector('.deferred-media');
//         if (deferredMedia) deferredMedia.loadContent(false);
//       }

//       preventStickyHeader() {
//         this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
//         if (!this.stickyHeader) return;
//         this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
//       }

//       removeListSemantic() {
//         if (!this.elements.viewer.slider) return;
//         this.elements.viewer.slider.setAttribute('role', 'presentation');
//         this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
//       }
//     }
//   );
// }





// ============================================================
// ELLA MEDIA GALLERY
// VARIANT CHANGE BLINK FIX
// ============================================================

if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {

      constructor() {
        super();

        this.elements = {
          liveRegion:
            this.querySelector('[id^="GalleryStatus"]'),

          viewer:
            this.querySelector('[id^="GalleryViewer"]'),

          thumbnails:
            this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql =
          window.matchMedia(
            '(min-width: 750px)'
          );

        /*
         * Keep the original Ella behavior.
         */
        if (!this.elements.thumbnails) return;


        // ======================================================
        // SLIDE CHANGE
        // ======================================================

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(
            this.onSlideChanged.bind(this),
            500
          )
        );


        // ======================================================
        // THUMBNAIL CLICK
        // ======================================================

        this.elements.thumbnails
          .querySelectorAll('[data-target]')
          .forEach((mediaToSwitch) => {

            const button =
              mediaToSwitch.querySelector('button');

            if (!button) return;


            button.addEventListener(
              'click',
              this.setActiveMedia.bind(
                this,
                mediaToSwitch.dataset.target,
                false
              )
            );

          });


        // ======================================================
        // DESKTOP LIST SEMANTIC
        // ======================================================

        if (
          this.dataset.desktopLayout &&
          this.dataset.desktopLayout.includes(
            'thumbnail'
          ) &&
          this.mql.matches
        ) {

          this.removeListSemantic();

        }

      }


      // ========================================================
      // CHECK VARIANT LOCK
      // ========================================================

      isVariantChanging() {

        return (
          this.dataset.variantChanging ===
          'true'
        );

      }


      // ========================================================
      // LOCK
      // ========================================================

      lockVariantGallery() {

        this.dataset.variantChanging =
          'true';

      }


      // ========================================================
      // UNLOCK
      // ========================================================

      unlockVariantGallery() {

        /*
         * Wait for DOM + browser paint to finish.
         * This prevents the old media from flashing.
         */

        requestAnimationFrame(() => {

          requestAnimationFrame(() => {

            delete this.dataset.variantChanging;

          });

        });

      }


      // ========================================================
      // SLIDE CHANGED
      // ========================================================

      onSlideChanged(event) {

        /*
         * IMPORTANT:
         * Do nothing while variant images
         * are being reordered.
         */

        if (
          this.isVariantChanging()
        ) {

          return;

        }


        if (
          !event.detail ||
          !event.detail.currentElement
        ) {

          return;

        }


        const mediaId =
          event.detail.currentElement.dataset.mediaId;


        if (!mediaId) return;


        const thumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );


        if (thumbnail) {

          this.setActiveThumbnail(
            thumbnail
          );

        }


        // ======================================================
        // ORIGINAL VIDEO AUTOPLAY
        // ======================================================

        setTimeout(() => {

          /*
           * Don't interfere with variant update.
           */

          if (
            this.isVariantChanging()
          ) {

            return;

          }


          const visibleVideos =
            document.querySelectorAll(
              '.product-media-container video'
            );


          visibleVideos.forEach(
            (video) => {

              if (video.paused) {

                video.play().catch(
                  (error) => {

                    console.log(
                      'Autoplay blocked:',
                      error
                    );

                  }
                );

              }

            }
          );

        }, 200);

      }


      // ========================================================
      // SET ACTIVE MEDIA
      // ========================================================

      setActiveMedia(
        mediaId,
        prepend
      ) {

        /*
         * ======================================================
         * MAIN BLINK FIX
         *
         * When Select Variant.js is updating the gallery,
         * Ella must NOT activate/scroll another image.
         * ======================================================
         */

        if (
          this.isVariantChanging()
        ) {

          return;

        }


        const activeMedia =
          this.elements.viewer.querySelector(
            `[data-media-id="${mediaId}"]`
          ) ||
          this.elements.viewer.querySelector(
            '[data-media-id]'
          );


        if (!activeMedia) {

          return;

        }


        // ======================================================
        // REMOVE ACTIVE FROM ALL
        // ======================================================

        this.elements.viewer
          .querySelectorAll(
            '[data-media-id]'
          )
          .forEach((element) => {

            element.classList.remove(
              'is-active'
            );

          });


        activeMedia.classList.add(
          'is-active'
        );


        // ======================================================
        // PREPEND
        // ======================================================

        if (prepend) {

          if (
            activeMedia.parentElement &&
            activeMedia.parentElement.firstChild !==
              activeMedia
          ) {

            activeMedia.parentElement.prepend(
              activeMedia
            );

          }


          if (this.elements.thumbnails) {

            const activeThumbnail =
              this.elements.thumbnails.querySelector(
                `[data-target="${mediaId}"]`
              );


            if (
              activeThumbnail &&
              activeThumbnail.parentElement &&
              activeThumbnail.parentElement.firstChild !==
                activeThumbnail
            ) {

              activeThumbnail.parentElement.prepend(
                activeThumbnail
              );

            }

          }


          if (
            this.elements.viewer.slider &&
            typeof this.elements.viewer.resetPages ===
              'function'
          ) {

            this.elements.viewer.resetPages();

          }

        }


        // ======================================================
        // STICKY HEADER
        // ======================================================

        this.preventStickyHeader();


        // ======================================================
        // SCROLL
        // ======================================================

        window.setTimeout(() => {

          /*
           * Variant update may have started
           * during this timeout.
           */

          if (
            this.isVariantChanging()
          ) {

            return;

          }


          if (
            !this.mql.matches ||
            this.elements.thumbnails
          ) {

            if (
              activeMedia.parentElement
            ) {

              activeMedia.parentElement.scrollTo({
                left:
                  activeMedia.offsetLeft
              });

            }

          }


          const activeMediaRect =
            activeMedia.getBoundingClientRect();


          /*
           * Don't scroll if already visible.
           */

          if (
            activeMediaRect.top > -0.5
          ) {

            return;

          }


          const top =
            activeMediaRect.top +
            window.scrollY;


          window.scrollTo({
            top: top,
            behavior: 'smooth'
          });

        });


        // ======================================================
        // PLAY MEDIA
        // ======================================================

        this.playActiveMedia(
          activeMedia
        );


        // ======================================================
        // THUMBNAIL
        // ======================================================

        if (
          !this.elements.thumbnails
        ) {

          return;

        }


        const activeThumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );


        if (!activeThumbnail) {

          return;

        }


        this.setActiveThumbnail(
          activeThumbnail
        );


        // ======================================================
        // ANNOUNCE
        // ======================================================

        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition
        );

      }


      // ========================================================
      // ACTIVE THUMBNAIL
      // ========================================================

      setActiveThumbnail(
        thumbnail
      ) {

        if (
          !this.elements.thumbnails ||
          !thumbnail
        ) {

          return;

        }


        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => {

            element.removeAttribute(
              'aria-current'
            );

          });


        const button =
          thumbnail.querySelector('button');


        if (!button) {

          return;

        }


        button.setAttribute(
          'aria-current',
          true
        );


        /*
         * Do not scroll thumbnails during
         * variant gallery update.
         */

        if (
          this.isVariantChanging()
        ) {

          return;

        }


        if (
          this.elements.thumbnails.isSlideVisible(
            thumbnail,
            10
          )
        ) {

          return;

        }


        if (
          this.elements.thumbnails.slider
        ) {

          this.elements.thumbnails.slider.scrollTo({
            left:
              thumbnail.offsetLeft
          });

        }

      }


      // ========================================================
      // LIVE REGION
      // ========================================================

      announceLiveRegion(
        activeItem,
        position
      ) {

        if (
          !this.elements.liveRegion ||
          !activeItem
        ) {

          return;

        }


        const image =
          activeItem.querySelector(
            '.product__modal-opener--image img'
          );


        if (!image) {

          return;

        }


        image.onload = () => {

          this.elements.liveRegion.setAttribute(
            'aria-hidden',
            false
          );


          if (
            window.accessibilityStrings &&
            window.accessibilityStrings.imageAvailable
          ) {

            this.elements.liveRegion.innerHTML =
              window.accessibilityStrings.imageAvailable
                .replace(
                  '[index]',
                  position
                );

          }


          setTimeout(() => {

            this.elements.liveRegion.setAttribute(
              'aria-hidden',
              true
            );

          }, 2000);

        };


        /*
         * Keep original Ella behavior.
         */

        image.src =
          image.src;

      }


      // ========================================================
      // PLAY ACTIVE MEDIA
      // ========================================================

      playActiveMedia(
        activeItem
      ) {

        if (
          typeof window.pauseAllMedia ===
          'function'
        ) {

          window.pauseAllMedia();

        }


        const deferredMedia =
          activeItem.querySelector(
            '.deferred-media'
          );


        if (deferredMedia) {

          deferredMedia.loadContent(
            false
          );

        }

      }


      // ========================================================
      // STICKY HEADER
      // ========================================================

      preventStickyHeader() {

        this.stickyHeader =
          this.stickyHeader ||
          document.querySelector(
            'sticky-header'
          );


        if (!this.stickyHeader) {

          return;

        }


        this.stickyHeader.dispatchEvent(
          new Event(
            'preventHeaderReveal'
          )
        );

      }


      // ========================================================
      // REMOVE LIST SEMANTIC
      // ========================================================

      removeListSemantic() {

        if (
          !this.elements.viewer.slider
        ) {

          return;

        }


        this.elements.viewer.slider.setAttribute(
          'role',
          'presentation'
        );


        this.elements.viewer.sliderItems
          .forEach((slide) => {

            slide.setAttribute(
              'role',
              'presentation'
            );

          });

      }

    }
  );
}

